import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import { LABEL } from '01_core/constants/labelConsts';
import { injectIntl } from 'react-intl';

const StyledHeaderDiv = styled('div')({
  height: 50,
});

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  minHeight: 50,
}));

const StyledAppTitle = styled(Typography)({
  marginLeft: 16,
  fontWeight: 'bold',
});

const StyledMessage = styled(Typography)({
  marginTop: 16,
  marginLeft: 8,
});

const NotAgree = (props) => {
  const { intl,} = props;
  return (
    <div>
    <StyledHeaderDiv>
      <CssBaseline />
      <AppBar position='fixed' color={'primary'}>
        <StyledAppBar>
          <Toolbar>
            <Typography
              variant='h5'
              color='inherit'
              noWrap
            >
              <StyledAppTitle>
                {intl.formatMessage({ id: LABEL.CORE_ONE_NEC })}
              </StyledAppTitle>
            </Typography>
          </Toolbar>
        </StyledAppBar>
      </AppBar>
    </StyledHeaderDiv>
    <Typography>
      <StyledMessage>
        {intl.formatMessage({ id: LABEL.COMMON_SYSLOGIN_PRIVACY_POLICY_NOT_AGREE })}
      </StyledMessage>
    </Typography>
    </div>
  );
}

export default injectIntl(NotAgree);
